import {
  Component,
  type ElementRef,
  inject,
  input,
  signal,
  ViewChild,
} from '@angular/core';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { ENVIRONMENT_CONFIG, getBrandName } from '@core/config-angular';
import { TranslatePipe } from '@ngx-translate/core';
import { CrntIcon, CrntVisuallyHidden } from '@essent/current-web-angular';
import type { GetReviewsResponseReview } from '@integration/api-client/reviews';
import { ReviewStarsComponent } from '@reviews/ui/stars';
import { SentenceCasePipe } from '@utils/pipes';

@Component({
  selector: 'wl-review-single',
  standalone: true,
  templateUrl: './review-single.component.html',
  styleUrls: [
    './review-single.component.essent.scss',
    './review-single.component.ed.scss',
  ],
  imports: [
    ReviewStarsComponent,
    DatePipe,
    TranslatePipe,
    CrntIcon,
    TitleCasePipe,
    CrntVisuallyHidden,
    SentenceCasePipe,
  ],
})
export class ReviewSingleComponent {
  readonly review = input.required<GetReviewsResponseReview>();

  @ViewChild('reviewText', { static: true }) reviewText!: ElementRef;

  readonly env = inject(ENVIRONMENT_CONFIG);

  readonly brand = getBrandName(this.env.brand);

  readonly reviewTextExpanded = signal(false);

  get reviewTextTruncated() {
    const reviewTextElement = this.reviewText.nativeElement;
    return reviewTextElement.scrollHeight > reviewTextElement.clientHeight;
  }

  onExpand(event: MouseEvent) {
    event.preventDefault();

    this.reviewTextExpanded.update((expanded) => !expanded);
  }
}
